import React from "react";
import "./header.scss";
import { useAuth } from "../../contexts/AuthContext";

const Header: React.FC = () => {
  const { user } = useAuth();
  
  const getLogoConfig = () => {
    const country = user?.country?.toUpperCase();
    if (country === "BELGIUM" || country === "BE") {
      return {
        file: "tempo-team-logo.png",
        alt: "Tempo-Team logo",
        height: "60px"  
      };
    }
    return {
      file: "randstad_basic.svg",
      alt: "Randstad logo",
      height: "40px" 
    };
  };

  const logo = getLogoConfig();

  return (
    <header className="app-header">
      <img 
        src={`/icons/${logo.file}`} 
        alt={logo.alt} 
        className="header-logo"
        style={{ height: logo.height }}
      />
    </header>
  );
};

export default React.memo(Header);